import { init, track } from '@plausible-analytics/tracker';

let initialized = false;

function initAnalytics() {
  try {
    if (initialized || !import.meta.env.VITE_PLAUSIBLE_DOMAIN) {
      return;
    }

    init({
      domain: import.meta.env.VITE_PLAUSIBLE_DOMAIN,
      captureOnLocalhost: false,
    });

    initialized = true;
  } catch (err) {
    console.error('Failed to initialize analytics:', err);
  }
}

function trackEvent(eventName, options = {}) {
  if (!initialized) {
    return;
  }

  track(eventName, options);
}

export {
  initAnalytics,
  trackEvent, 
};